import { formatUtcDate } from 'App/services/DateService';

const utcDateFilter = (rows, [columnId], filterValue) => {
    return rows.filter((row) => {
        return formatUtcDate({ date: row.values[columnId] })?.includes(filterValue);
    });
};

export default utcDateFilter;
